import React, { useContext, useEffect, useState } from 'react';
import { Router } from 'react-router-dom';
import styles from './App.module.scss';
import history from 'libs/history';
import routes from './config/routes';
import { CurrentUserContext } from 'context/currentUserContext';
import { decodeUrlSearchToObject } from 'libs/utils';
import { EnumRoles } from 'services/user';
import { Routes } from '@hrtps/ui';

function App() {
    const { user } = useContext(CurrentUserContext);
    const [validRoutes, setValidRoutes] = useState(routes());

    useEffect(() => {
        let searchObj = decodeUrlSearchToObject(window.location.search);
        if (searchObj['tenantId']) {
            localStorage.setItem('x-header-tid', searchObj['tenantId']);
        }
    }, []);

    useEffect(() => {
        console.log(user?.type);
        setValidRoutes(filterRoutesByUserType(user?.type || ''));
    }, [user]);

    const recurseFilterRoutes = (
        routes: IRoute[],
        pathFilter: (r: IRoute) => boolean | undefined
    ) => {
        routes = routes.filter(r => pathFilter(r));
        routes.forEach(r => {
            if (r.routes) {
                r.routes = recurseFilterRoutes(r.routes, pathFilter);
            }
        });
        return routes;
    };

    const filterRoutesByUserType = (userType?: string) => {
        const _routes: IRoute[] = routes();
        if (userType === EnumRoles.ADMIN) {
            return _routes;
        } else if (userType === EnumRoles.OPERATOR) {
            // TODO:: 后续再增加对应的菜单即可
            recurseFilterRoutes(_routes, (r: IRoute): boolean => {
                return (
                    r.path?.includes('/algorithm/manage') ||
                    r.path?.includes('/product/tenant/list') ||
                    r.path === '/'
                );
            });
        } else {
            // recurseFilterRoutes(_routes, (r: IRoute): boolean => {
            //     return (
            //       r.path === '/'
            //     );
            //   });
        }
        return _routes;
    };

    return (
        <div className={styles.root}>
            <Router history={history}>
                <Routes routes={validRoutes} />
            </Router>
        </div>
    );
}
export default App;
